import * as React from "react";

import { ObservableValue } from "azure-devops-ui/Core/Observable";

import { Link } from "azure-devops-ui/Link";
import { Location } from "azure-devops-ui/Utilities/Position";
import { Observer } from "azure-devops-ui/Observer";
import { TeachingBubble, TeachingBubbleCornerPlacement } from "azure-devops-ui/TeachingBubble";

export default class TextOnlyTeachingBubbleExample extends React.Component {
    private showBubble = new ObservableValue<boolean>(false);
    private teachingBubbleRoot: HTMLDivElement;

    public render() {
        return (
            <div
                style={{ margin: "8px" }}
                className="flex-row flex-center flex-grow justify-center"
            >
                <div ref={this.callbackRef}>
                    <Link
                        href="https://dev.azure.com/mseng/AzureDevOps/_wiki/wikis/AzureDevOps.wiki?wikiVersion=GBwikiMaster&pagePath=%2FRead%20this%20first&pageId=2384"
                        target="_blank"
                    >
                        Wiki
                    </Link>
                </div>
                <Observer showBubble={this.showBubble}>
                    {(props: { showBubble: boolean }) => {
                        return props.showBubble ? (
                            <TeachingBubble
                                anchorElement={this.teachingBubbleRoot}
                                anchorOrigin={{
                                    horizontal: Location.center,
                                    vertical: Location.start
                                }}
                                cornerPlacement={TeachingBubbleCornerPlacement.vertical}
                                onDismiss={() => (this.showBubble.value = false)}
                                text="The wiki is a great place to get started."
                                textOnly={true}
                            />
                        ) : null;
                    }}
                </Observer>
            </div>
        );
    }

    private callbackRef = (element: HTMLDivElement) => {
        this.teachingBubbleRoot = element;
        this.showBubble.value = true;
    };
}
